<template>
  <div class="contact">
    <base-banner
			:title="banner.title"
			:caption="banner.caption"
			:backgroundImage="banner.image"
			:titleColor="banner.titleColor"
			:captionColor="banner.captionColor"
			:backgroundColor="banner.backgroundColor"
			:buttons="banner.buttons"
		>
		</base-banner>

		<base-goto :breadcrumbs="breadcrumbs"></base-goto>

		<base-divider></base-divider>

		<div id="form" class="sec">
			<v-container>
				<v-row justify="center">
					<div
						class="head"
						data-aos="fade-up"
						:class="MIXIN_SETUP_UI.header"
					>
						Contact Form
					</div>
				</v-row>

				<v-form ref="contactForm">
					<v-row>
						<v-col
							cols="12" sm="12" md="6" lg="6" xl="6"
							:class="$vuetify.breakpoint.mdAndUp ? 'box-left' : 'px-5'"
							data-aos="fade-right"
						>
							<!-- Title -->
							<v-btn
								v-for="(val, key) in titles"
								:key="key"
								width="10%"
								rounded
								depressed
								:color="val.color"
								dark
								:class="`${val.class} mr-2`"
								@click="title = val.value"
								:small="MIXIN_SETUP_UI.isSmallButton"
								:x-large="!MIXIN_SETUP_UI.isSmallButton"
							>
								{{ val.title }}
								<v-badge
									color="#14cb94"
									v-if="title == val.value"
									icon="mdi-check"
								>
								</v-badge>
							</v-btn>

							<!-- First Name -->
							<v-text-field
								label="First Name*"
								type="text"
								ref="country"
								v-model="firstName"
								:rules="[() => !!firstName || 'This field is required']"
								:error-messages="errorMessages"
								class="mt-3"
							></v-text-field>

							<!-- Last Name -->
							<v-text-field
								label="Last Name*"
								type="text"
								ref="lastName"
								v-model="lastName"
								:rules="[() => !!lastName || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

							<!-- Email -->
							<v-text-field
								label="Email*"
								type="text"
								ref="email"
								v-model="email"
								:rules="[() => !!email || 'This field is required',
													() => /.+@.+\..+/.test(email) || 'Email must be valid']"
								:error-messages="errorMessages"
							></v-text-field>

							<!-- Phone Number -->
							<v-text-field
								label="Phone Number*"
								type="text"
								ref="phoneNumber"
								v-model="phoneNumber"
								:rules="[() => !!phoneNumber || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

							<!-- Company -->
							<v-text-field
								label="Company*"
								type="text"
								ref="company"
								v-model="company"
								:rules="[() => !!company || 'This field is required']"
								:error-messages="errorMessages"
							></v-text-field>

							<!-- Message -->
							<v-textarea
								label="Message"
								auto-grow
								ref="message"
								v-model="message"
							></v-textarea>

							<!-- Submit button -->
							<base-button
								name="Submit"
								color="#1665ce"
								@click="confirmContactInfo()"
								x-large
								min-width="50%"
								class="mt-5"
							></base-button>
						</v-col>
						<v-col
							cols="12" sm="12" md="6" lg="6" xl="6"
							:class="$vuetify.breakpoint.mdAndUp ? 'box-right' : 'px-5'"
							data-aos="fade-left"
						>
							<div class="primary--text mb-5 font-weight-bold" :class="MIXIN_SETUP_UI.header">
								Be heard.<br>We'd love to hear your insights.<br>We are listening.
							</div>

							<div class="py-4">
								<div
									class="primary--text mb-3 font-weight-black"
									:class="MIXIN_SETUP_UI.header"
								>
									Telemedicine Center
								</div>

								<table>
									<tr v-for="(contact, key) in contacts" :key="key">
										<td class="pr-5 font-weight-bold">{{ contact.label }}:</td>
										<td>
											<span
												class="ma-0 pa-0"
												v-for="(number, index) in contact.numbers"
												:key="index"
											>
												{{ number }}
												<span v-if="(contact.numbers.length - 1) != index"> / </span>
											</span>
										</td>
									</tr>
								</table>
							</div>

							<div class="py-4">
								<h2 class="primary--text mb-3">Social Media</h2>

								<div>
									<a v-for="(val, key) in medias" :key="key" :href="val.link">
										<v-btn
											fab
											outlined
											class="ma-2"
											:small="MIXIN_SETUP_UI.isSmallButton"
											:medium="!MIXIN_SETUP_UI.isSmallButton"
										>
											<v-icon>mdi-{{ val.media }}</v-icon>
										</v-btn>
									</a>
								</div>
							</div>
						</v-col>
					</v-row>
				</v-form>
			</v-container>
		</div>

		<base-confirm-dialog
			v-model="confirmDialog"
			title="Confirm"
			message="Would you like to send this message?"
			@do="saveContactInfo()"
		></base-confirm-dialog>

		<base-success-dialog
			v-model="successDialog"
			title="Thank you!"
			message="You have successfully submitted your message."
		></base-success-dialog>
  </div>
</template>

<script>
import Repository from "@/api/repositories";
const ContactBannerApi = Repository.get("contactBanners");
const FootersApi = Repository.get("footers");
const FormEmailApi = Repository.get("formEmails");

export default {
  name: "Contact",
  components: {
  },
  data() {
    return {
			/* form fields */
			title: '',
			firstName: null,
			lastName: null,
			email: null,
			phoneNumber: null,
			company: null,
			message: null,
			/* form fields */
			errorMessages: '',
			confirmDialog: false,
			successDialog: false,
			banner: [],
			titles: [
				{
					title: "Mrs.",
					value: "mrs",
					color: "#c2dffc",
					class: "blue--text text--darken-3"
				},
				{
					title: "Ms.",
					value: "ms",
					color: "#40ecb8",
					class: "white--text"
				},
				{
					title: "Mr.",
					value: "mr",
					color: "#1665ce",
					class: "white--text"
				}
			],
			contacts: [],
			medias: [
				{
					media: "facebook",
					link: "https://www.facebook.com/medgatephilippines"
				},
				{
					media: "instagram",
					link: "https://www.instagram.com/medgatephilippines"
				},
				{
					media: "twitter",
					link: "https://twitter.com/MedgatePH"
				},
				{
					media: "youtube",
					link: "https://www.youtube.com/channel/UCXUY81i4niHSwMiOsse9LEw"
				},
				{
					media: "linkedin",
					link: "https://www.linkedin.com/company/medgate-philippines"
				},
			],
			breadcrumbs: [
				{
					name: "Medgate",
					link: "/",
					active: false
				},
        {
					name: "Contact Us",
					link: "/contact",
					active: true
				},
			]
		}
	},
	computed: {
		contactForm() {
      return {
        title: this.title,
				firstName: this.firstName,
				lastName: this.lastName,
				email: this.email,
				phoneNumber: this.phoneNumber,
				company: this.company,
				message: this.message,
      }
    },
	},
  async mounted() {
		this.getContacts();
		await this.getContactBanner();
		this.setHeaderColor();
  },
  methods: {
		setHeaderColor() {
      if (this.banner.backgroundColor)
        this.$store.commit('page/setHeaderColor', this.banner.backgroundColor)
      else
        this.$store.commit('page/defaultHeaderColor')
    },
    async getContactBanner() {
      try {
        const { data } = await ContactBannerApi.get();
        
        if (data) {
          data.data.sort(function(a, b) {
            return a.precedence - b.precedence;
          });
          
          let apiData = data.data[0];

          let buttons = apiData.buttons.map(button => {
            return {
              name: button.label,
              icon: button.image,
              link: button.redirect,
              color: JSON.parse(button.styling).color
            }
          });

          let banner = {
            buttons: buttons,
            image: apiData.background_image.main,
            caption: apiData.caption,
            title: apiData.title,
            titleColor: apiData.styles.titleColor,
            captionColor: apiData.styles.captionColor,
            backgroundColor: apiData.styles.backgroundColor
          }

          this.banner = banner;
        }

        console.log('[contact-banner]', data, this.banner);
      }
      catch(error) {
        console.log(error);
      }
		},
		async getContacts() {
				try {
					const { data } = await FootersApi.get();
					
					if (data) {
						var values = [];

						data.data.map(contact => {
							values = contact.values.contacts.map(value => {
								return {
									label: value.label,
									numbers: value.numbers
								}
							});
						});

						this.contacts = values;
					}

					console.log('[contacts]', data, this.contacts);
				}
				catch(error) {
					console.log(error);
				}
		},
		confirmContactInfo() {
      if (this.$refs.contactForm.validate()) this.confirmDialog = true;
		},
		async saveContactInfo() {
			this.confirmDialog = false;

			try {
				/**
				* key = contact-us because request is coming from contact-us form
				*/
				let key = "contact-us";
				let form = {
					key,
					data: JSON.stringify(this.contactForm),
					...this.contactForm
				};

				let save = await FormEmailApi.createViaKey(key, form);

				if (save) {
					this.successDialog = true;
				}
				else {
					console.log("Sorry, there was a problem saving your transaction.");
				}
			}
			catch(error) {
				console.log(error);
			}
		}
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

.contact {
	#form {
		background: white;
	}

	.box-left {
		padding: 0px 100px 0px 100px;
	}

	.box-right {
		padding: 0px 0px 0px 0px;
	}
}
</style>